<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment'
    
   export default {
      page: {
         title: "Schedules",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Schedules",
            items: [
               {
                  text: "Doctors",
                  href: "/doctors",
               },                
               
               {
                  text: "Schedules",
                  active: true,
               },                     
            ],

            video_consultation: [
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
            ],          

            home_consultation: [
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
            ],

            clinic_consultation: [
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
            ],

            video_consultation_checked: false,
            home_consultation_checked: false,
            clinic_consultation_checked: false,            

            start: '',
            end: '',
            day: null,
            type: '',            
            duration:'',
            token_type:'',
            set_time:'',
            hour:'',
            minutes:'',
            time_name:'',
            clinic_id:'',
            consultation_fee:'',
            home_location: '',
            home_marker: { position: { lat: null, lng: null } },
            home_center: { lat: null, lng: null },
            home_current_place: null,

            home_mapOptions: {
               disableDefaultUI: true,
            },
            same_in_week:2,
            video: {},
            home: {},
            clinic: {}, 
            clinic_name:"",
            active_durations: [],
            durations: [],            
            
            video_durations: [],
            home_durations: [],
            clinic_durations: [],

            consultation: {
               address: '',
               clinic_id: '',
               commision: '',
               consultation_fee: '',
               consultation_type: '',
               duration_id: '',
               latitude: '',
               longitude: '',
               location: '',
               place: '',
            },
            pin_no: "",

            video_schedules: [],
            home_schedules: [],
            clinic_schedules: [],

            video_del_session_ids: [],
            home_del_session_ids: [],
            clinic_del_session_ids: [],

            clinics: [],

            errors: {},
            video_errors: {},
            home_errors: {},
            clinic_errors: {},
            token: '',
            form_type: '',           

         };
      },
      
      mounted() {
    
      },

      created() {
         this.fetchDurations();
         this.fetchActiveDurations();
         this.fetchClinics(1);
         this.fetchSchedules();
      },
      watch: {
         clinic_id(newClinicId) {
            const selectedClinic = this.clinics.find(clinic => clinic.id === newClinicId.id);
            if (selectedClinic) {
               this.consultation_fee = selectedClinic.fee; // Set the consultation fee based on the selected clinic
            } else {
               this.consultation_fee = ''; // Reset the fee if no clinic is selected
            }
         },
         start() {
         this.start = this.start.split(":").slice(0, 2).join(":");
         },
         end() {
         this.end = this.end.split(":").slice(0, 2).join(":");
         },
         duration() {
         this.duration = this.duration.split(":").slice(0, 2).join(":");
         },
      },
      methods: {

         getToken() {
            if (localStorage.getItem('sigohealth_admin')) {
               var sigohealth_admin =  JSON.parse(localStorage.getItem('sigohealth_admin'));
               if(sigohealth_admin.token) {
                  this.token = sigohealth_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 
       
         fetchSchedules() {
            let url = "api/admin/doctors/schedule_detailsNew?doctor_id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               // console.log(responseData);

               this.video = responseData.video;  
               if(this.video) {
                  this.video_consultation_checked = true;
                  this.video_durations = this.durations;

                  if(this.video.sessions.length > 0) {
                     this.setConsultations('video');
                  }
               }  else {
                  this.video = this.consultation; // intialize 
                  this.video_durations = this.active_durations;
               }  

               this.clinic = responseData.clinic;
               if(this.clinic) {
                  this.clinic_consultation_checked = true;
                  this.clinic_durations = this.durations;
                  if(this.clinic.sessions.length > 0) {
                     this.setConsultations('clinic');
                  }
               } else {
                  this.clinic = this.consultation;
                  this.clinic_durations = this.active_durations;
               }               

               
               this.home = responseData.home;
               if(this.home) {
                  this.home_consultation_checked = true;
                  this.home_durations = this.durations;

                  this.home_location = this.home.location;
                  this.home_marker = { position: { lat: parseFloat(this.home.latitude), lng: parseFloat(this.home.longitude) } };
                  this.home_center = { lat: parseFloat(this.home.latitude), lng: parseFloat(this.home.longitude) };

                  if(this.home.sessions.length) {
                     this.setConsultations('home');
                  }
               } else {
                  this.home = this.consultation;
                  this.home_durations = this.active_durations;
               }         

               
                     
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
         setTime(){
            this.set_time = this.duration;
            this.hour = this.set_time.split(':')[0];
            this.minutes = this.set_time.split(':')[1];
            this.time_name = this.hour+' Hour '+ this.minutes +' minutes ';
            return  this.time_name;
         }, 

         setConsultations(type) {
            var sessions;

            var consultation = [
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
            ];     

            var schedules = [];

            if(type == 'video') {
               sessions = this.video.sessions;

            } else if(type == 'home') {
               sessions = this.home.sessions;

            } else if(type == 'clinic') {
               sessions = this.clinic.sessions;

            }
            console.log("to",type);


            sessions.forEach(obj => {

               var session = {};
               session.start = obj.start_time;
               session.end = obj.end_time;
               session.session_id = obj.id;
               session.day = obj.day_id;
               session.duration = obj.duration;
               session.token_type = obj.token_type;
               session.clinic_name = obj.clinic_name;
               session.fee = obj.consultation_fee;


               var set_time = obj.duration;
               if(set_time){
                  var hour = set_time.split(':')[0];
                  var minutes = set_time.split(':')[1];
                  if(hour!='00'){
                     session.time_name = hour+' Hr '+ minutes +' min ';
                  }else{
                     session.time_name =  minutes +' min ';
                  }
               }
               var index = parseInt(obj.day_id) - 1;
               consultation[index].day.push(session); 

               var schedule = {};
               schedule.day = obj.day_id;               
               schedule.start = moment.utc('2002-02-02 ' + obj.start_time).format('hh:mm A');
               schedule.end = moment.utc('2002-02-02 ' + obj.end_time).format('hh:mm A');
               schedule.duration = obj.duration;
               schedule.token_type = obj.token_type;
               schedule.clinic_id = obj.clinic_id;
               schedule.consultation_fee = obj.consultation_fee;
               schedules.push(schedule); 
               console.log("me",type);

            });
            if(type == 'video') {
               this.video_consultation = consultation;
               this.video_schedules = schedules;

            } else if(type == 'home') {
               this.home_consultation = consultation;
               this.home_schedules = schedules;

            } else if(type == 'clinic') {
               console.log("hi",schedules);

               this.clinic_consultation = consultation;
               this.clinic_schedules = schedules;
            }


         },     

         fetchClinics() {
              
            let url = "api/admin/getClinicsFee?doctor_id=" + this.$route.params.id;        
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  // console.log(responseData);
                  this.clinics = responseData.clinics;
               })
               .catch((err) => console.log(err));
         },

         fetchDurations() {
            let url = "api/admin/get-durations?type=2"; 

            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  this.durations = responseData.durations;
               })
               .catch((err) => {
                  console.log(err)
               });
         },

         fetchActiveDurations() {
            let url = "api/admin/get-durations?type=1"; 

            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  // console.log(responseData);
                  this.active_durations = responseData.durations;
               })
               .catch((err) => {
                  console.log(err)
               });
         },

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         isSessionAddable(day, type) {
            this.day = day;
            this.type = type;

            this.getToken();          
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            var ctype = 0;
            var count = 0;
            if(type == 'video') {
               ctype = 1;
               count = this.clinic_consultation[day].day.length;
            } else if(type == 'home') {
               ctype = 2;
               count = this.clinic_consultation[day].day.length;
            } else if(type == 'clinic') {
               ctype = 3;
               count = this.clinic_consultation[day].day.length;
            }


            let formData = new FormData();
            formData.append("doctor_id", this.$route.params.id); 
            formData.append("type", ctype); 
            formData.append("day", day + 1); 
            formData.append("count", count); 
            

            let url = "api/admin/doctors/schedules/isSLotAddable2"; 
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  // console.log(response);
                  if (response.data.status) {
                     this.showModal('session-modal');
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
            })
            .catch((error) => {
                  if (error.response) {
                     // console.log(error.response);
                     if(error.response.status == 400) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        if (error.response.data.message) {
                           this.$swal("", "Something went wrong", "error");
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false)); 
         },

         durationCheck(){

            let startingTime = moment(this.start, 'HH:mm');
            let endingTime = moment(this.end, 'HH:mm');

            let schedule_duration = moment.duration(endingTime.diff(startingTime)).asMinutes();
            let reserved_duration = moment.duration(this.duration).asMinutes();

            if (reserved_duration > schedule_duration) {
               this.$swal("", "Consultation duration is greater than slot duration!", "error");
            } else {
               this.sessionCheck();
            }

         },

         sessionCheck() {
            this.getToken();          
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            var c_type = 0;

            if (this.type == 'video') {
               c_type = 1;
            } else if (this.type == 'home') {
               c_type = 2;
            } else if (this.type == 'clinic') {
               c_type = 3;
            }

            // Use c_type somewhere in the code
            // console.log(c_type); // Example usage

            let formData = new FormData();
            formData.append("start_time", this.start); 
            formData.append("end_time", this.end); 
            formData.append("duration", this.duration); 
            formData.append("type", c_type); 
            if(c_type == '3'){
               formData.append("clinic_id", this.clinic_id); 
               formData.append("fee", this.consultation_fee); 
               formData.append("reserved", this.token_type); 
            }

            let url = "api/admin/doctors/schedules/sessionCheck"; 
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  // console.log(response);
                  if (response.data.status) {
                     this.addSession();
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
            })
            .catch((error) => {
                  if (error.response) {
                     // console.log(error.response);
                     if(error.response.status == 400) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           this.$swal("", "Something went wrong", "error");
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false)); 
         },
         updateClinicName() {
            this.clinic_name = this.clinic_id.name;
         },
         addSession() { 
            
            var datetime1 = '2002-02-02 ' + this.start;
            var start = moment.utc(datetime1).format('hh:mm A');
            var datetime2 = '2002-02-02 ' + this.end;
            var end = moment.utc(datetime2).format('hh:mm A');
            var set_time = this.duration;
               if(set_time){
                  var hour = set_time.split(':')[0];
                  var minutes = set_time.split(':')[1];
                  if(hour!='00'){
                     this.time_name = hour+' Hr '+ minutes +' min ';
                  }else{
                     this.time_name =  minutes +' min ';
                  }
               }
            if(this.start > this.end) {
               this.$swal("", "Invalid time slot", "error");
               return;
            }
      

            /////////////////
            //Checking if slot time already present in any of the consultation types starts
            
            var invalid = false;           
            const hasOverlap = (newstart, newend, slots) => {
               return slots.some(slot => 
                  (newstart > slot.start && newstart < slot.end) || // Partial overlap: new start is within range
                  (newend > slot.start && newend < slot.end) ||    // Partial overlap: new end is within range
                  (slot.start >= newstart && slot.end <= newend) || // Full containment
                  (newstart == slot.start && newend == slot.end)   // Exact match
               );
            };
            const hasOverlapWithoutSame = (newstart, newend, slots) => {
               return slots.some(slot => 
                  (newstart > slot.start && newstart < slot.end) || // Partial overlap: new start is within range
                  (newend > slot.start && newend < slot.end) ||    // Partial overlap: new end is within range
                  (slot.start > newstart && slot.end < newend) 
               );
            };
            const checkExactMatch = (newstart, newend, slots) => {
               const exactMatch = slots.find(slot => {
                  if (newstart === slot.start && newend === slot.end) {
                     return true;
                  }
                  return false; // Ensure other slots are checked
               });
               if (exactMatch) {
                  if(this.type != 'clinic') {
                     // Check if the duration matches
                     if (exactMatch.duration != this.duration+ ":00") {
                           return true; // If duration doesn't match, return false
                     }
                  }else{
                     if (exactMatch.duration == this.duration+ ":00" && exactMatch.clinic_name == this.clinic_name && exactMatch.token_type == this.token_type) {
                        return false; // If duration doesn't match, return false
                     }else{
                        return true;
                     }
                  }
               }
               return false; // No exact match found
            };
            Object.entries(this.video_consultation).forEach(([key,val]) => {
               var newstart = this.start + ":00";
               var newend = this.end + ":00";
               if (this.same_in_week == 2) {
                  if (key == this.day) {
                        if (hasOverlap(newstart, newend, val['day'])) {
                           invalid = true;
                        }
                  }
               } else {
                  if(this.type != 'video') {
                     if (hasOverlap(newstart, newend, val['day'])) {
                           invalid = true;
                     }
                  }else{
                     if (hasOverlapWithoutSame(newstart, newend, val['day'])) {
                           invalid = true;
                     }else if (checkExactMatch(newstart, newend, val['day'])) {
                           invalid = true;
                     }
                  }
               }
               if (invalid) return; // Early exit if conflict found
            });
            Object.entries(this.home_consultation).forEach(([key,val]) => {
               var newstart = this.start + ":00";
               var newend = this.end + ":00";
               if (this.same_in_week == 2) {
                  if (key == this.day) {
                        if (hasOverlap(newstart, newend, val['day'])) {
                           invalid = true;
                        }
                  }
               } else {
                  if(this.type != 'home') {
                     if (hasOverlap(newstart, newend, val['day'])) {
                           invalid = true;
                     }
                  }else{
                     if (hasOverlapWithoutSame(newstart, newend, val['day'])) {
                           invalid = true;
                     }else if (checkExactMatch(newstart, newend, val['day'])) {
                           invalid = true;
                     }
                  }
               }
               if (invalid) return; // Early exit if conflict found
            });

            Object.entries(this.clinic_consultation).forEach(([key,val]) => {
               var newstart = this.start + ":00";
               var newend = this.end + ":00";
               if (this.same_in_week == 2) {
                  if (key == this.day) {
                        if (hasOverlap(newstart, newend, val['day'])) {
                           invalid = true;
                        }
                  }
               } else {
                  if(this.type != 'clinic') {
                     if (hasOverlap(newstart, newend, val['day'])) {
                           invalid = true;
                     }
                  }else{
                     if (hasOverlapWithoutSame(newstart, newend, val['day'])) {
                           invalid = true;
                     }else if (checkExactMatch(newstart, newend, val['day'])) {
                           invalid = true;
                     }
                  }
               }
               if (invalid) return; // Early exit if conflict found
            });
            
            //Checking if slot time already present in any of the consultation types ends
            /////////////////

            if(this.type == 'video') {
               Object.entries(this.video_consultation).forEach(([key,val]) => {
                  if (this.same_in_week == 2) {
                     if(key == this.day) {                     
                        if(!invalid) {
                           val['day'].push({start: this.start + ':00', end: this.end + ':00', day: this.day + 1,duration: this.duration + ':00',time_name: this.time_name});
                           this.video_schedules.push({day: this.day + 1, start: start, end: end, duration: this.duration});
                           console.log('day',val['day']);
                           console.log('video_schedules',this.video_schedules);

                        } else {
                           this.$swal("", "Time already included in video, home or clinic consultation", "error");
                        }
                     }
                  }else{
                     
                     const formattedDay = String(parseInt(key) + 1);
                     console.log(formattedDay);
                     const newStart = this.start + ':00';
                     const newEnd = this.end + ':00';
                     if(!invalid) {
                        const alreadyIncluded = val['day'].some(slot => 
                           slot.start === newStart &&
                           slot.end === newEnd &&
                           slot.duration === this.duration + ':00'
                        );
                     if (!alreadyIncluded) {
                           // Push the new schedule if it doesn't already exist
                           val['day'].push({
                              start: newStart,
                              end: newEnd,
                              day: formattedDay,
                              duration: this.duration + ':00',
                              time_name: this.time_name,
                           });

                           this.video_schedules.push({
                              day: formattedDay,
                              start: start,
                              end: end,
                              duration: this.duration,
                           });
                        }
                     } else {
                        this.$swal("", "Time already included in video, home or clinic consultation", "error");
                     }
                  }
               });
            } else if(this.type == 'home') {
               Object.entries(this.home_consultation).forEach(([key,val]) => {
                  if (this.same_in_week == 2) {
                     if(key == this.day) {                     
                        if(!invalid) {
                           val['day'].push({start: this.start + ':00', end: this.end + ':00', day: this.day + 1,duration: this.duration + ':00',time_name: this.time_name});
                           this.home_schedules.push({day: this.day + 1, start: start, end: end, duration: this.duration});
                        } else {
                           this.$swal("", "Time already included in video, home or clinic consultation", "error");
                        }
                     }
                  }else{
                     const formattedDay = String(parseInt(key) + 1).padStart(2, '0');
                     const newStart = this.start + ':00';
                     const newEnd = this.end + ':00';
                     if(!invalid) {
                        const alreadyIncluded = val['day'].some(slot => 
                           slot.start === newStart &&
                           slot.end === newEnd &&
                           slot.duration === this.duration + ':00'
                        );
                     if (!alreadyIncluded) {
                           // Push the new schedule if it doesn't already exist
                           val['day'].push({
                              start: newStart,
                              end: newEnd,
                              day: formattedDay,
                              duration: this.duration + ':00',
                              time_name: this.time_name,
                           });

                           this.home_schedules.push({
                              day: formattedDay,
                              start: start,
                              end: end,
                              duration: this.duration,
                           });
                        }
                     } else {
                        this.$swal("", "Time already included in video, home or clinic consultation", "error");
                     }
                  }
               });
            } else if(this.type == 'clinic') {
               Object.entries(this.clinic_consultation).forEach(([key,val]) => {
                  if (this.same_in_week == 2) {
                     if(key == this.day) {                     
                        if(!invalid) {
                           val['day'].push({start: this.start + ':00', end: this.end + ':00', day: this.day + 1,duration: this.duration + ':00',clinic_id: this.clinic_id, token_type: this.token_type, consultation_fee: this.consultation_fee,clinic_name: this.clinic_id.name, fee: this.consultation_fee,time_name: this.time_name});
                           this.clinic_schedules.push({day: this.day + 1, start: start, end: end, duration: this.duration,clinic_id: this.clinic_id.id, token_type: this.token_type, consultation_fee: this.consultation_fee});
                        } else {
                           this.$swal("", "Time already included in video, home or clinic consultation", "error");
                        }
                     }
                  }else{
                     const formattedDay = String(parseInt(key) + 1).padStart(2, '0');
                    
                     if(!invalid) {
                        const clinicName = this.clinic_id.name || '';
                        const clinicId = this.clinic_id.id || this.clinic_id;

                        // Check if the slot already exists
                        const alreadyIncluded = val['day'].some(slot => {
                           return (
                              slot.start === this.start + ':00' &&
                              slot.end === this.end + ':00' &&
                              slot.duration === this.duration + ':00' &&
                              slot.token_type === Number(this.token_type) &&
                              slot.clinic_name === this.clinic_name
                           );
                        });
                        if (!alreadyIncluded) {
                              // Push the new schedule if it doesn't already exist
                           val['day'].push({
                                 start: this.start + ':00',
                                 end: this.end + ':00',
                                 day: formattedDay,
                                 duration: this.duration + ':00',
                                 clinic_id: clinicId,
                                 token_type: this.token_type,
                                 consultation_fee: this.consultation_fee,
                                 clinic_name: clinicName,
                                 fee: this.consultation_fee,
                                 time_name: this.time_name
                              });

                           // Add to clinic schedules
                           this.clinic_schedules.push({
                              day: formattedDay,
                              start: start,
                              end: end,
                              duration: this.duration,
                              clinic_id: clinicId,
                              token_type: this.token_type,
                              consultation_fee: this.consultation_fee
                           });
                        }
                     } else {
                        this.$swal("", "Time already included in video, home or clinic consultation", "error");
                     }
                  }
               });
            }
            this.clearSession();
            this.$refs['session-modal'].hide();
         },
         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         },

         checkPin() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/check_pin_no";

            let formData = new FormData();
            formData.append("pin_no", this.pin_no); 
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     // this.$swal("", response.data.message, "success");
                     this.hideModal('pin-modal');
                     if(this.form_type == 'video'){
                        this.addVideoSchedule();
                     }else if(this.form_type == 'home'){
                        this.addHomeSchedule();
                     }else if(this.form_type == 'clinic'){
                        this.addClinicSchedule();
                     }
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        this.$swal("", error.response.data.message, "error");

                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         }, 

         clearSession() {
            this.start = '';
            this.end = '';
            this.day = null;
            this.type = '';
            this.duration = '';
            this.consultation_fee = '';
            this.clinic_id = '';
            this.token_type = '';
            this.time_name = ''; 
            this.errors = {};
            this.pin_no = ''; 
            this.form_type = ''; 
            this.same_in_week = 2;
            this.clinic_name= ''; 
         },   
         clearForm() {
            this.errors = {};
            this.pin_no = ''; 
            this.form_type = ''; 
         },

         removeSession(obj, index, type) {
            // console.log(obj[index]);

            // console.log(type);
            var session = obj[index];
            // console.log(session);

            this.getToken();          
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            var ctype = 0;
            if(type == 'video') {
               ctype = 1;
            } else if(type == 'home') {
               ctype = 2;
            } else if(type == 'clinic') {
               ctype = 3;
            }


            let formData = new FormData();
            formData.append("doctor_id", this.$route.params.id); 
            formData.append("type", ctype); 
            formData.append("day_id", session.day); 
            formData.append("start_time", session.start); 
            formData.append("end_time", session.end); 

            let url = "api/admin/doctors/schedules/isDeletable"; 
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  // console.log(response);
                  if (response.data.status) {

                     //******* if is deletable starts *******//

                     var start = moment.utc('2002-02-02 ' + session.start).format('hh:mm A');
                     var end = moment.utc('2002-02-02 ' + session.end).format('hh:mm A');

                     if(type == 'video') {
                        if(session.session_id) {
                           this.video_del_session_ids.push(session.session_id);
                        }
                        // console.log(this.video_schedules);

                        this.video_schedules.forEach(video => {                  
                           if(session.day == video.day && 
                              start == video.start && 
                              end == video.end) {
                              this.video_schedules.splice(this.video_schedules.indexOf(video), 1);
                           }
                           console.log(this.video_schedules);
                           console.log(session.day);
                           console.log(video.day);
                           console.log(start);
                           console.log(video.start);
                           console.log(end);
                           console.log(video.end);

                        });
                        // console.log(this.video_schedules);
                     }    

                     if(type == 'home') {
                        if(session.session_id) {
                           this.home_del_session_ids.push(session.session_id);
                        }

                        this.home_schedules.forEach(home => {                  
                           if(session.day == home.day && 
                              start == home.start && 
                              end == home.end) {
                              this.home_schedules.splice(this.home_schedules.indexOf(home), 1);
                           }
                        });
                     }          

                     if(type == 'clinic') {
                        if(session.session_id) {
                           this.clinic_del_session_ids.push(session.session_id);
                        }

                        this.clinic_schedules.forEach(clinic => {                  
                           if(session.day == clinic.day && 
                              start == clinic.start && 
                              end == clinic.end) {
                              this.clinic_schedules.splice(this.clinic_schedules.indexOf(clinic), 1);
                           }
                        });
                     }                

                     obj.splice(index, 1);

                     //******* if is deletable ends *******//
                     
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
            })
            .catch((error) => {
                  if (error.response) {
                     console.log(error.response);
                     if(error.response.status == 400) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        if (error.response.data.message) {
                           //this.errors = error.response.data.message;
                           //console.log(this.errors);
                           this.$swal("", "Something went wrong", "error");
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));      
            
            
              
         }, 

         // geolocate() {
         //    navigator.geolocation.getCurrentPosition((position) => {
         //       this.clinic_marker.position = {
         //         lat: position.coords.latitude,
         //         lng: position.coords.longitude,
         //       };
         //       this.panToMarker();
     //        });
      //    },


         addVideoSchedule() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/doctors/addVideoScheduleNew2";  
       
            let formData = new FormData();

            formData.append("doctor_id", this.$route.params.id); 
            formData.append("consultation_fee", this.video.consultation_fee); 
            formData.append("commision", this.video.commision); 
            formData.append('schedules', JSON.stringify(this.video_schedules));

            formData.append('del_session_ids', JSON.stringify(this.video_del_session_ids));
            
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
               this.$router.go();

               })
               .catch((error) => {
                  console.log(error.response);
                  if (error.response) {
                     if (error.response.data.message) {
                        if(error.response.status == 422) {
                           this.video_errors = error.response.data.message;
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         }, 
         handleFormSubmit(form_type) {
            this.showModal("pin-modal");
            this.form_type = form_type;         
         },
         addHomeSchedule() {
            
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/doctors/addHomeScheduleNew2";  
       
            let formData = new FormData();

            formData.append("doctor_id", this.$route.params.id); 
            formData.append("consultation_fee", this.home.consultation_fee); 

            formData.append("place", this.home.place);
            formData.append("address", this.home.address);
            formData.append("location", this.home_location);
            formData.append("latitude", this.home_marker.position.lat);
            formData.append("longitude", this.home_marker.position.lng);

            formData.append('schedules', JSON.stringify(this.home_schedules));
            formData.append('del_session_ids', JSON.stringify(this.home_del_session_ids));
            
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
               this.$router.go();

               })
               .catch((error) => {
                  console.log(error.response);
                  if (error.response) {
                     if (error.response.data.message) {
                        if(error.response.status == 422) {
                           this.home_errors = error.response.data.message;
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },    

         addClinicSchedule() {
            
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/doctors/addClinicScheduleNew2";  
       
            let formData = new FormData();

            formData.append("doctor_id", this.$route.params.id); 
            formData.append('schedules', JSON.stringify(this.clinic_schedules));
            formData.append('del_session_ids', JSON.stringify(this.clinic_del_session_ids));
            
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
               this.$router.go();
               })
               .catch((error) => {
                  console.log(error.response);
                  if (error.response) {
                     if (error.response.data.message) {
                        if(error.response.status == 422) {
                           this.errors = error.response.data.message;
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },         


         //sets the position of marker when dragged
         homeHandleMarkerDrag(e) {
            this.clinic_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         homePanToMarker() {
            this.$refs.homeMapRef.panTo(this.clinic_marker.position);
            this.$refs.homeMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         homeHandleMapClick(e) {
            this.home_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         homeSetPlace(place) {
            this.home_current_place = place;
            if(this.home_current_place) {
               const marker = {
                  lat: this.home_current_place.geometry.location.lat(),
                  lng: this.home_current_place.geometry.location.lng(),
               };
               this.home_center = marker;
               this.home_marker.position = marker;
               this.home_location = place.formatted_address;
            }
         },
      }
   }
</script>

<style type="text/css">
   .schedules table td {
      padding: 10px;
   }

   .schedules table td .row {
      padding: 0;
   }
</style>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <router-link :to="{ name: 'doctors' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  
                  <!------ Video Consultation starts ----------> 
                  <b-card header-class="bg-transparent border-light" class="border border-light schedules"> 
                  <!-- <form @submit.prevent="addVideoSchedule()">                         -->
                     <form @submit.prevent="handleFormSubmit('video')">
                     <h5 class="card-title mb-4">
                        Video Consultation                           
                        <div class="form-check form-switch float-end">
                           <input class="form-check-input" type="checkbox"  v-model="video_consultation_checked"/>
                        </div>
                     </h5>                      
                     <div class="row m-0" v-if="video_consultation_checked">
                        <div class="col-md-6 col-lg-7 col-xl-7">
                           <label>Session Timings <span class="text-danger">*</span></label>
                           <div class="table-responsive">
                                    
                              <table class="table table-bordered w-100">

                                 <!---- Monday starts-------->
                                 <tr>                                      
                                    <td scope="row">Mon</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-for="(session, index) in video_consultation[0].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }} | {{session.time_name}} <span @click="removeSession(video_consultation[0].day, index, 'video')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=0, type='video'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(0, 'video')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Monday ends -------->

                                 <!---- Tuesday starts-------->
                                 <tr>
                                    <td>Tue</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-for="(session, index) in video_consultation[1].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(video_consultation[1].day, index, 'video')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=1, type='video'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(1, 'video')"><i class="fas fa-plus-circle"></i></b-button>
                                             
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Tuesday ends-------->

                                 <!---- Wednesday starts-------->
                                 <tr>
                                    <td>Wed</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-for="(session, index) in video_consultation[2].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(video_consultation[2].day, index, 'video')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=2, type='video'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(2, 'video')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Wednesday starts-------->

                                 <!---- Thursday starts-------->
                                 <tr>
                                    <td>Thu</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-for="(session, index) in video_consultation[3].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(video_consultation[3].day, index, 'video')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=3, type='video'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(3, 'video')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Thursday starts-------->

                                 <!---- Friday starts-------->
                                 <tr>
                                    <td>Fri</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-for="(session, index) in video_consultation[4].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(video_consultation[4].day, index, 'video')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=4, type='video'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(4, 'video')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Friday starts-------->

                                 <!---- Saturday starts-------->
                                 <tr>
                                    <td>Sat</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-for="(session, index) in video_consultation[5].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(video_consultation[5].day, index, 'video')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=5, type='video'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(5, 'video')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Saturday ends-------->

                                 <!---- Sunday starts-------->
                                 <tr>
                                    <td>Sun</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-for="(session, index) in video_consultation[6].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(video_consultation[6].day, index, 'video')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                   
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=6, type='video'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(6, 'video')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Sunday ends-------->


                              </table>
                           </div>
                        </div>
                        <div class="col-md-6 col-lg-5 col-xl-5 consultation-details">
                           <div class="form-group">
                              <label>Consultation Fee (in Rs.) <span class="text-danger">*</span></label>
                              <input type="text" class="form-control" v-model="video.consultation_fee" v-bind:class="{ 'is-invalid': Boolean(video_errors.consultation_fee) }"/>
                              <div v-for="(val, index) in video_errors.consultation_fee" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>   
                        </div>
                        <div class="col-12 my-2">
                           <button type="submit" class="btn btn-primary me-2">Submit</button>
                           <router-link :to="{ name: 'doctors' }" class="btn btn-light">Cancel</router-link>
                        </div>
                     </div>
                     <div class="row" v-else>
                        <div class="col-12">
                           <!-- <p>Not scheduled</p> -->
                        </div>
                     </div>   
                     
                  </form>         
                  </b-card>
                  <!------ Video Consultation ends ---------->                          
                  <!------ Home Consultation starts ----------> 
                  <b-card header-class="bg-transparent border-light" class="border border-light schedules">  
                  <!-- <form @submit.prevent="addHomeSchedule()"> -->
                     <form @submit.prevent="handleFormSubmit('home')">
                     <h5 class="card-title mb-4">
                        Home Consultation                           
                        <div class="form-check form-switch float-end">
                           <input class="form-check-input" type="checkbox"  v-model="home_consultation_checked"/>
                        </div>
                     </h5>                      
                     <div class="row m-0" v-if="home_consultation_checked">
                        <div class="col-md-6 col-lg-7 col-xl-7">
                           <label>Session Timings <span class="text-danger">*</span></label>
                           <div class="table-responsive">
                                    
                              <table class="table table-bordered w-100">

                                 <!---- Monday starts-------->
                                 <tr>                                      
                                    <td scope="row">Mon</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-for="(session, index) in home_consultation[0].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(home_consultation[0].day, index, 'home')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=0, type='home'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(0, 'home')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Monday ends -------->

                                 <!---- Tuesday starts-------->
                                 <tr>
                                    <td>Tue</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-for="(session, index) in home_consultation[1].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(home_consultation[1].day, index, 'home')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=1, type='home'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(1, 'home')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Tuesday ends-------->

                                 <!---- Wednesday starts-------->
                                 <tr>
                                    <td>Wed</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-for="(session, index) in home_consultation[2].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(home_consultation[2].day, index, 'home')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=2, type='home'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(2, 'home')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Wednesday starts-------->

                                 <!---- Thursday starts-------->
                                 <tr>
                                    <td>Thu</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-for="(session, index) in home_consultation[3].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(home_consultation[3].day, index, 'home')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=3, type='home'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(3, 'home')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Thursday starts-------->

                                 <!---- Friday starts-------->
                                 <tr>
                                    <td>Fri</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-for="(session, index) in home_consultation[4].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(home_consultation[4].day, index, 'home')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=4, type='home'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(4, 'home')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Friday starts-------->

                                 <!---- Saturday starts-------->
                                 <tr>
                                    <td>Sat</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-for="(session, index) in home_consultation[5].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(home_consultation[5].day, index, 'home')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=5, type='home'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(5, 'home')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Saturday ends-------->

                                 <!---- Sunday starts-------->
                                 <tr>
                                    <td>Sun</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-for="(session, index) in home_consultation[6].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(home_consultation[6].day, index, 'home')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=6, type='home'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(6, 'home')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Sunday ends-------->

                              </table>
                           </div>
                        </div>
                        <div class="col-md-6 col-lg-5 col-xl-5 consultation-details">
                           <div class="form-group">
                              <label>Consultation Fee (in Rs.) <span class="text-danger">*</span></label>
                              <input type="text" class="form-control" v-model="home.consultation_fee" v-bind:class="{ 'is-invalid': Boolean(home_errors.consultation_fee) }"/>

                              <div v-for="(val, index) in home_errors.consultation_fee" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>   

                           <div class="form-group">
                              <label>Place<span class="text-danger">*</span></label>
                              <input type="text" class="form-control" v-model="home.place" v-bind:class="{ 'is-invalid': Boolean(home_errors.place) }"/>

                              <div v-for="(val, index) in home_errors.place" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>   

                           <div class="form-group">
                              <label>Address<span class="text-danger">*</span></label>
                              <input type="text" class="form-control" v-model="home.address" v-bind:class="{ 'is-invalid': Boolean(home_errors.address) }"/>

                              <div v-for="(val, index) in home_errors.address" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>  

                        </div>

                        <b-col md="12" class="mb-3">
                              <label class="control-label">Location <span class="text-danger">*</span></label>
                              <GmapAutocomplete @place_changed="homeSetPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search here..."  :value="home_location"/>
                              <div class="" v-if="home_location">
                              <GmapMap
                                 :center="home_center"
                                 :zoom="18"
                                 map-style-id="home-roadmap"
                                 :options="home_mapOptions"
                                 style="width: 100%; height: 50vmin"
                                 ref="homeMapRef"
                                 @click="homeHandleMapClick">
                                    <GmapCustomMarker
                                       :position="home_marker.position"
                                       :clickable="true"
                                       :draggable="true"
                                       @drag="homeHandleMarkerDrag"
                                       @click="homePanToMarker"
                                    />
                              </GmapMap>
                              </div>                          
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Latitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="home_marker.position.lat" v-bind:class="{ 'is-invalid': Boolean(home_errors.latitude) }"></b-form-input>

                              <div v-for="(val, index) in home_errors.latitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                              
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Longitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="home_marker.position.lng" v-bind:class="{ 'is-invalid': Boolean(home_errors.longitude) }"></b-form-input>

                              <div v-for="(val, index) in home_errors.longitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                              
                           </b-col>
                        <div class="col-12 my-2">
                           <button type="submit" class="btn btn-primary me-2">Submit</button>
                           <router-link :to="{ name: 'doctors' }" class="btn btn-light">Cancel</router-link>
                        </div>
                     </div>
                     <div class="row" v-else>
                        <div class="col-12">
                           <!-- <p>Not scheduled</p> -->
                        </div>
                     </div>   
                     
                  </form>         
                  </b-card>
                  <!------ Home Consultation ends ---------->

                  <!------ Clinic Consultation starts ----------> 
                  <b-card header-class="bg-transparent border-light" class="border border-light schedules"> 
                  <!-- <form @submit.prevent="addClinicSchedule()"> -->
                     <form @submit.prevent="handleFormSubmit('clinic')">
                        <h5 class="card-title mb-4">
                        Clinic Consultation                           
                        <div class="form-check form-switch float-end">
                           <input class="form-check-input" type="checkbox"  v-model="clinic_consultation_checked"/>
                        </div>
                     </h5>
                     <ul class="reservervation-defs">
                        <li><i class="fas fa-square not-reserved-color"></i> Token Vending Machine Only</li>
                        <li><i class="fas fa-square reserved-color"></i> Both</li>
                     </ul>                       
                     <div class="row m-0" v-if="clinic_consultation_checked">
                        <div class="col-md-6 col-lg-7 col-xl-7">
                           <label>Session Timings <span class="text-danger">*</span></label>
                           <div class="table-responsive">
                                    
                              <table class="table table-bordered w-100">

                                 <!---- Monday starts-------->
                                 <tr>                                      
                                    <td scope="row">Mon</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1, 'not-reserved': session.token_type == 2 }" v-for="(session, index) in clinic_consultation[0].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(clinic_consultation[0].day, index, 'clinic')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                                <p class="clinic-name">{{session.clinic_name }} | Fee:{{ session.fee }}</p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=0, type='clinic'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button  variant="success" class="btn-sm" @click="isSessionAddable(0, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Monday ends -------->

                                 <!---- Tuesday starts-------->
                                 <tr>
                                    <td>Tue</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 , 'not-reserved': session.token_type == 2}" v-for="(session, index) in clinic_consultation[1].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(clinic_consultation[1].day, index, 'clinic')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                                <p class="clinic-name">{{session.clinic_name}} | Fee:{{ session.fee }}</p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=1, type='clinic'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(1, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Tuesday ends-------->

                                 <!---- Wednesday starts-------->
                                 <tr>
                                    <td>Wed</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 , 'not-reserved': session.token_type == 2}" v-for="(session, index) in clinic_consultation[2].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(clinic_consultation[2].day, index, 'clinic')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                                <p class="clinic-name">{{session.clinic_name}} | Fee:{{ session.fee }}</p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=2, type='clinic'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(2, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Wednesday starts-------->

                                 <!---- Thursday starts-------->
                                 <tr>
                                    <td>Thu</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag"  v-bind:class="{ 'reserved': session.token_type == 1 , 'not-reserved': session.token_type == 2}" v-for="(session, index) in clinic_consultation[3].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(clinic_consultation[3].day, index, 'clinic')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                                <p class="clinic-name">{{session.clinic_name}} | Fee:{{ session.fee }}</p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=3, type='clinic'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(3, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Thursday starts-------->

                                 <!---- Friday starts-------->
                                 <tr>
                                    <td>Fri</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 , 'not-reserved': session.token_type == 2}" v-for="(session, index) in clinic_consultation[4].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(clinic_consultation[4].day, index, 'clinic')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                                <p class="clinic-name">{{session.clinic_name}} | Fee:{{ session.fee }}</p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=4, type='clinic'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(4, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Friday starts-------->

                                 <!---- Saturday starts-------->
                                 <tr>
                                    <td>Sat</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag"  v-bind:class="{ 'reserved': session.token_type == 1 , 'not-reserved': session.token_type == 2}" v-for="(session, index) in clinic_consultation[5].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(clinic_consultation[5].day, index, 'clinic')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                                <p class="clinic-name">{{session.clinic_name}} | Fee:{{ session.fee }}</p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=5, type='clinic'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(5, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Saturday ends-------->

                                 <!---- Sunday starts-------->
                                 <tr>
                                    <td>Sun</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1, 'not-reserved': session.token_type == 2 }" v-for="(session, index) in clinic_consultation[6].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(clinic_consultation[6].day, index, 'clinic')" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                                <p class="clinic-name">{{session.clinic_name}} | Fee:{{ session.fee }}</p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=6, type='clinic'"><i class="fas fa-plus-circle"></i></b-button> -->
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(6, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Sunday ends-------->

                              </table>
                           </div>
                        </div>

                        <div class="col-12 my-2">
                           <button type="submit" class="btn btn-primary me-2">Submit</button>
                           <router-link :to="{ name: 'doctors' }" class="btn btn-light">Cancel</router-link>
                        </div>
                     </div>
                     <div class="row" v-else>
                        <div class="col-12">
                           <!-- <p>Not scheduled</p> -->
                        </div>
                     </div>   
                     
                  </form>         
                  </b-card>
                  <!------ Clinic Consultation ends ---------->

               </div>
            </div>
         </div>
      </div>

         <!---- modal starts ---->
         <b-modal ref="session-modal" id="session-modal" title="Add Session" hide-footer @hidden="clearSession()">
            <!-- <b-form @submit.prevent="addSession()">                         -->
               <b-form @submit.prevent="durationCheck()">                        
                  <div class="form-group">
                     <b-form-checkbox
                        v-model="same_in_week"
                        name="sameInWeek"
                        value="1"
                        unchecked-value="2"
                     >
                     <span class="ms-2">Same Timing For All Days</span>
                     </b-form-checkbox>
                  </div>
               <div class="form-group" v-if="type=='clinic'">
                  <label>Clinic <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="clinic_id" @change="updateClinicName()"  v-bind:class="{ 'is-invalid': Boolean(errors.clinic_id) }" >
                     <option value="" v-if="!clinic_id">Select</option>
                     <option :value="{ id: clinic.id, name: clinic.name }" v-for="clinic in clinics" :key="clinic.id">{{clinic.name}}</option>
                  </select>
                  <div v-for="(val, index) in errors.clinic_id" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p></div>
               </div>                    
               <div class="form-group" v-if="type=='clinic'">
                  <label>Consultation Fee <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" v-model="consultation_fee" v-bind:class="{ 'is-invalid': Boolean(errors.fee) }"/>
                  <div v-for="(val, index) in errors.fee" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p></div>
               </div>
               <b-col md="12" class="form-group">
                  <label class="control-label">Start Time<span class="text-danger">*</span></label>
                  <b-input-group class="mb-3">
                     <b-form-input id="example-input" v-model="start" type="text" placeholder="HH:mm" v-bind:class="{ 'is-invalid': Boolean(errors.start_time) }" readonly></b-form-input>
                     <b-input-group-append><b-form-timepicker v-model="start" button-only right :show-seconds="false" :locale="'it'" :hour12="false" format="HH:mm" aria-controls="example-input"></b-form-timepicker></b-input-group-append>
                     <div v-for="(val, index) in errors.start_time" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
                  </b-input-group>
                     
               </b-col>              
               <b-col md="12" class="form-group">
                  <label class="control-label">End Time<span class="text-danger">*</span></label>
                  <b-input-group class="mb-3">
                     <b-form-input id="example-input" v-model="end" type="text" placeholder="HH:mm" v-bind:class="{ 'is-invalid': Boolean(errors.end_time) }" readonly></b-form-input>
                     <b-input-group-append><b-form-timepicker v-model="end" button-only right :show-seconds="false" :locale="'it'" :hour12="false" format="HH:mm" aria-controls="example-input"></b-form-timepicker></b-input-group-append>
                     <div v-for="(val, index) in errors.end_time" :key="index" class="invalid-feedback">
                        <p class="mb-0">{{ val }}</p>
                     </div>
                  </b-input-group>
               </b-col>
                   
               <b-row md="12" class="form-group">
                
                <b-col md="6" class="form-group">
                   <label>Consultation Duration <span class="text-danger">*</span></label>
                  <b-input-group class="mb-3">
                     <b-form-input id="example-input" v-model="duration"  @input="setTime()" type="text" placeholder="HH:mm" readonly v-bind:class="{ 'is-invalid': Boolean(errors.duration) }"></b-form-input>
                     <b-input-group-append>
                        <b-form-timepicker v-model="duration" @input="setTime()" button-only right :show-seconds="false" :locale="'it'" :hour12="false" format="HH:mm" aria-controls="example-input"></b-form-timepicker>
                     </b-input-group-append>
                     <div v-for="(val, index) in errors.duration" :key="index" class="invalid-feedback">
                        <p class="mb-0">{{ val }}</p>
                     </div>
                  </b-input-group>
                  <span class="ms-1"> {{time_name}}</span>
                </b-col>
                <b-col md="6" class="form-group" v-if="type=='clinic'">

                   <label>Reserved For <span class="text-danger">*</span></label>
                      <select class="form-control" v-model="token_type" v-bind:class="{ 'is-invalid': Boolean(errors.reserved) }">
                        <option value="">Select</option>
                         <option value="2">Token Vending Machine</option>
                         <option value="1">Both </option>
                      </select>
                      <div v-for="(val, index) in errors.reserved" :key="index" class="invalid-feedback">
                        <p class="mb-0">{{ val }}</p></div>
                </b-col>
             </b-row>
               <b-col md="12">
                  <b-button type="submit" class="me-3" variant="primary">OK</b-button>
                  <b-button class="" variant="light" @click="$bvModal.hide('session-modal')">Cancel</b-button>
               </b-col>

            </b-form>
         </b-modal>
         <!---- modal ends ----->

          <!---- modal starts ---->
       <b-modal ref="pin-modal" id="pin-modal" title="" hide-footer @hidden="clearForm()">
         <b-form @submit.prevent="checkPin()">
            <b-row>  
               <b-col lg="12" class="form-group">
                  <label class="control-label">Pin Number<span class="text-danger">*</span></label>
                  <b-form-input v-model="pin_no" @keypress="numbersOnly" autocomplete="off" maxlength="4" v-bind:class="{ 'is-invalid': Boolean(errors.pin_no) }"></b-form-input>

                  <div v-for="(val, index) in errors.pin_no" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col>  
               
               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Submit</b-button>
                  <b-button class="" variant="light" @click="hideModal('pin-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->

   </Layout>
</template>
